import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { BustSizeButton } from 'page/ProfileScreen/BustSizes/BustSizeButton'

export const BustSizes = observer(() => {
  return <Panel>
    <BustSizeButton bust={1} />
    <BustSizeButton bust={2} />
    <BustSizeButton bust={3} />
    <BustSizeButton bust={4} />
  </Panel>
})
